import { NgModule } from '@angular/core';
import { PublishDialogService, RepublishDialogService, UnpublishDialogService } from '@mode/dataset/contract';
import { PublishDatasetDialogService } from './publish-dataset-dialog/publish-dataset-dialog.service';
import { UnpublishDatasetDialogService } from './unpublish-dataset-dialog/unpublish-dataset-dialog.service';
import { PublishDatasetBannerComponent } from './publish-dataset-banner/publish-dataset-banner.component';
import { RepublishDatasetDialogService } from './republish-dataset-dialog/republish-dataset-dialog.service';

@NgModule({
  imports: [PublishDatasetBannerComponent],
  providers: [
    { provide: PublishDialogService, useClass: PublishDatasetDialogService },
    { provide: UnpublishDialogService, useClass: UnpublishDatasetDialogService },
    { provide: RepublishDialogService, useClass: RepublishDatasetDialogService },
  ],
})
export class PublishModule {}
